import React from "react";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <div className="flex flex-wrap justify-between px-4 py-10 bg-gray-900 sm:px-8">
      <Link to="/" style={{ textDecoration: "none", color: "white" }}>
        <h2 className="text-base text-white md:text-lg">MOVIE STORM</h2>
      </Link>
      <a
        href="https://themoviedb.org"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white transition-colors duration-150 border-b-2 border-gray-400 hover:text-gray-400 hover:border-gray-600"
        id="powered"
      >
        Powered by The Movie DB
      </a>
    </div>
  );
}
